import { when } from '@execonline-inc/maybe-adapter';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../EmptyFragment';
import { T } from '../../../../../../Translations';
import Button from '../../../../../Form/Button';
import InfoIcon from './InfoIcon';

interface Props {
  creating: () => void;
  possibleShareUrlCount: number;
}

function ShareUrlBanner({ possibleShareUrlCount, creating }: Props) {
  return when(possibleShareUrlCount > 0, true)
    .map(() => (
      <div
        className={clsx(
          'rounded-sm bg-yellow-50 border-yellow-300 flex justify-between w-4/5 lg:my-12',
          'my-2.5 mx-auto p-5 border-2',
        )}
      >
        <div className="flex items-center">
          <InfoIcon />
          <div className="flex flex-col">
            <span className="font-bold">
              <T kind="Add New Program Deep Links" />
            </span>
            <span>
              <T
                kind="Your collection has been updated. {{count}} new Program Deep Link can be added for this collection."
                count={possibleShareUrlCount}
              />
            </span>
          </div>
        </div>
        <Button
          className="rounded-md bg-teal-600 px-6 py-2 text-white"
          value="Add Deep Links"
          onClick={creating}
          type="button"
        />
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ShareUrlBanner);
